import React from 'react';
import {
  buttonStylesForProjects,
  defaultCommandBarButtonStyles,
  titleCommandBarButtonStyles,
} from '../../../../styles/button-styles';
import ViewWrapperWithCommandBar from '../../../Common/Layout/ViewWrapperWithCommandBar';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { Text, DefaultPalette } from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import ComboBoxInput from '../../../../lib/FormValidator/Form/ComboBoxInput';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../common/routes';
import SystemClient from '../../../../system/SystemClient';
import MessageCourier from '../../../../lib/MessageCourier';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useAsyncDataCourier from '../../../../common/custom-hooks/useAsyncDataCourier';
import { DefaultButton, Label, Pivot, PivotItem, PrimaryButton } from '@fluentui/react';
import PlanillaPartidoForm from '../../PlanillaPartidoForm';
import { CampoJuegoSelectorInput } from '../../../CampoJuego/CampoJuegoSelector';
import { useCustomInput } from '../../../../common/custom-hooks/useCustomInput';
import { Partido } from '../../../../system/Partido/Partido';
import { TeamCardForConfeccion } from './ConfeccionPlanillaPartido';
import CustomInputIfc from '../../../../lib/FormValidator/Form/CustomInputIfc';
import { DatePickerInput } from '../../../../lib/FormValidator/Form/DatePickerInput';
import { HourSelector } from '../../../Common/HourSelector';
import { ArbitroSelectorInput } from '../../../Arbitro/ArbitroSelector_old';
import { PlanillaPartidoContext } from '../../../../system/PlanillaPartido/PlanillaPartidoSystem';
import { OficialMesaSelectorInput } from '../../../OficialMesa/OficialMesaSelector';
import ConfeccionPlanillaPartidoTeam from './ConfeccionPlanillaPartidoTeam';
import PlanillaPartidoOficialMesaNoRegsitradoForm from '../../../PlanillaPartidoOficialMesaNoRegsitrado/PlanillaPartidoOficialMesaNoRegsitradoForm';
import InputField from '../../../../lib/FormValidator/Form/InputField';
import { PlanillaPartidoOficialMesaNoRegsitrado } from '../../../../system/PlanillaPartidoOficialMesaNoRegsitrado/PlanillaPartidoOficialMesaNoRegsitrado';
import { IComboBoxOption } from '@fluentui/react';

interface IOficialMesaNoRegistradoView {
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  form: PlanillaPartidoForm;
  partido: Partido;
  context: PlanillaPartidoContext;
  eqId: string;
  setEquipoId: (id: string) => void;
}

const OficialMesaNoRegistradoView = ({
  system,
  courier,
  changeBlockUI,
  form,
  partido,
  context,
  eqId,
  setEquipoId,
}: IOficialMesaNoRegistradoView) => {
  const [planillaPartidoOficialMesaNoRegsitradoForm, setPlanillaPartidoOficialMesaNoRegsitradoForm] =
    React.useState<PlanillaPartidoOficialMesaNoRegsitradoForm>(
      PlanillaPartidoOficialMesaNoRegsitradoForm.initialize()
    );

  const [formIsValid, setFormIsValid] = React.useState(false);

  const equipoIdInput = useCustomInput(
    () => planillaPartidoOficialMesaNoRegsitradoForm.getEqidInput(),
    [planillaPartidoOficialMesaNoRegsitradoForm]
  );

  React.useEffect(() => {
    if (eqId) {
      planillaPartidoOficialMesaNoRegsitradoForm.getEqidInput().setValue(eqId);
    }
  }, [eqId]);

  const onClickSave = async () => {
    try {
      changeBlockUI(true);
      const newOficialesNoRegistrados = [...form.getOficialesMesaNoRegistradosInput().getValue()];
      newOficialesNoRegistrados.push(
        PlanillaPartidoOficialMesaNoRegsitrado.createForPlanilla(
          +eqId,
          planillaPartidoOficialMesaNoRegsitradoForm.getNombreInput().getValue(),
          planillaPartidoOficialMesaNoRegsitradoForm.getApellidoInput().getValue(),
          planillaPartidoOficialMesaNoRegsitradoForm.getDniInput().getValue(),
          false
        )
      );
      form.getOficialesMesaNoRegistradosInput().setValue(newOficialesNoRegistrados);
      setEquipoId('');
    } catch (err) {
      courier.messageError(err);
    } finally {
      changeBlockUI(false);
    }
  };

  const onBlurCustomInput = (customInput: CustomInputIfc) => {
    console.log('planillaPartidoOficialMesaNoRegsitradoForm > ', planillaPartidoOficialMesaNoRegsitradoForm);
    setFormIsValid(planillaPartidoOficialMesaNoRegsitradoForm.isValid());
  };

  return (
    <>
      <div className="ms-Grid-row mt-5">
        <div className="ms-Grid-col ms-sm12">
          <Text className="mb-1" variant="medium" style={{ fontWeight: 600, fontSize: 16 }}>
            Registrar oficial de mesa
          </Text>
        </div>
      </div>
      <div className="ms-Grid-row mt-3">
        <div className="ms-Grid-col ms-sm2">
          <InputField
            input={planillaPartidoOficialMesaNoRegsitradoForm.getNombreInput()}
            label={'Nombre (*)'}
            onBlur={onBlurCustomInput}
          />
        </div>
        <div className="ms-Grid-col ms-sm2">
          <InputField
            input={planillaPartidoOficialMesaNoRegsitradoForm.getApellidoInput()}
            label={'Apellido (*)'}
            onBlur={onBlurCustomInput}
          />
        </div>
        <div className="ms-Grid-col ms-sm2">
          <InputField
            input={planillaPartidoOficialMesaNoRegsitradoForm.getDniInput()}
            label={'Dni (*)'}
            onBlur={onBlurCustomInput}
          />
        </div>
      </div>
      <div className="ms-Grid-row mt-2">
        <div className="ms-Grid-col ms-sm12" style={{ display: 'flex' }}>
          {/* <Label className="hidden">Guardar</Label> */}

          <PrimaryButton
            disabled={
              !formIsValid
              // !planillaPartidoOficialMesaNoRegsitradoForm.getNombreInput().getValue() &&
              // !planillaPartidoOficialMesaNoRegsitradoForm.getApellidoInput().getValue() &&
              // !planillaPartidoOficialMesaNoRegsitradoForm.getEqidInput().getValue()
            }
            onClick={() => onClickSave()}
          >
            Guardar
          </PrimaryButton>
          {/* <Label className="hidden">Cancelar</Label> */}
          <DefaultButton onClick={() => setEquipoId('')} style={{ marginLeft: '10px' }}>
            Cancelar
          </DefaultButton>
        </div>
      </div>
    </>
  );
};

export default OficialMesaNoRegistradoView;
